module.exports = __webpack_public_path__ + "static/media/外壁.7a3a9e40.jpg";